export { FeaturedItems } from './FeaturedItems';
